import i18n from '@dms/i18n';

/**
 * Marks a field label as overridden, so the user sees which values no longer follow the template.
 */
export function getOverrideLabel(label: string, isOverridden: boolean) {
  return isOverridden ? `${label} (${i18n.t('general.labels.custom').toLocaleLowerCase()})` : label;
}
